import { render, staticRenderFns } from "./ContactFormFields.vue?vue&type=template&id=b12f6062"
import script from "./ContactFormFields.vue?vue&type=script&lang=js"
export * from "./ContactFormFields.vue?vue&type=script&lang=js"
import style0 from "./ContactFormFields.vue?vue&type=style&index=0&id=b12f6062&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports